import {http} from './config';
export default{
    save:(empresa)=>{
        return http.post('api/empresa',empresa)
    },
    delete:()=>{
        return http.delete('api/empresa/')
    },
    obtenerEmpresaPorUsuario:()=>{
        return http.get('api/empresa/')
    }
}
